// Pure cache-enable decision for the local message cache. app.svelte.ts's
// cacheOn() reads the LIVE input — the localStorage "cyborg7:cache" flag — and
// delegates here, so the decision itself is side-effect-free and unit-testable
// (app.svelte.ts has import-time side effects and can't be imported into a unit
// test).
//
// EVERY SURFACE CACHES. This used to be limited to the "persistent shells" (iOS
// native, Electron desktop, Tauri Android) with plain web off unless the flag
// opted it in. That exclusion was never a technical limit — the module's own note
// said the blast radius of being wrong was one toggle — and it made the cache
// invisible on the surface most of the product is used from: a web tab re-fetched
// the whole conversation on every click and sat on a skeleton while it waited.
// The store is IndexedDB, which every browser we support has and which Mattermost
// persists its own web app to with no such carve-out.
//
// The shared-browser worry the carve-out was really about is answered by the OWNER
// WIPE, not by staying off: cacheInit (./index.ts) keys the store on the signed-in
// EMAIL and clears L1+L2 when a different human logs in on the same device. That
// runs from connectToServer behind this very decision, so turning web on is what
// arms it there — see cache-owner.test.ts's plain-web case.
//
// The localStorage flag still decides in BOTH directions: "off" is the field kill
// switch (no redeploy, reaches every platform), anything else leaves the cache on.
// On a cache MISS or any error the prior network-first path runs unchanged, and
// every helper short-circuits when `indexedDB` is undefined — so the blast radius
// is still one toggle.
export function decideCacheEnabled(opts: {
  flag: string | null; // localStorage "cyborg7:cache"
}): boolean {
  return opts.flag !== "off"; // kill switch is the only thing that turns it off
}
